import { getUserMetadata } from "../services/userMetadataService";

export const getStoredCompanyId = () => {
  try {
    const info = JSON.parse(localStorage.getItem("client_info") || "null");
    if (info?.CompanyId || info?.companyId) return info.CompanyId || info.companyId;
  } catch {}
  const stored = localStorage.getItem("company_id");
  if (stored) return stored;
  try {
    const legacy = JSON.parse(localStorage.getItem("getAzureUserData") || "null");
    if (legacy?.CompanyId) return legacy.CompanyId;
  } catch {}
  return null;
};

export const resolveCompanyId = async (instance, accounts) => {
  const cached = getStoredCompanyId();
  if (cached) return cached;
  try {
    // getUserMetadata is an Identity API — must use the user's identity token,
    // not the generic DMS token stored under "vizy-bility-token".
    const header = { authorization: `Bearer ${localStorage.getItem("vizy-identity-token")}` };
    const res = await getUserMetadata(header, instance, accounts);
    const data = res?.data;
    let id = data?.companyId || data?.CompanyId;
    if (!id && data?.additionalMetadata) {
      try { id = JSON.parse(data.additionalMetadata)?.companyId; } catch {}
    }
    if (id) { localStorage.setItem("company_id", String(id)); return id; }
  } catch {}
  return null;
};
